import React from 'react';
import Hero from '../../sections/Hero/Hero';

function Header() {
  return (
    <section id="header" className="header">
      <Hero />
    </section>
  );
}

export default Header;